// extracted by mini-css-extract-plugin
export var accountPageTabs = "account-page-tabs_OcJ7ABZ7MOGc17KUgCQf";